import slice from "./slice";
export * from "./sagas/getRepositories";
export * from "./sagas/deleteRepository";
export * from "./sagas/refetchRepository";

export default slice;
